// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PinIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25",
  "aria-hidden": "true",
  "data-icon": "Pin/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.734 4.408a.567.567 0 0 0 .567-.567v-.137A.704.704 0 0 0 16.594 3l-8.521.043a.683.683 0 0 0-.68.708l.004.102c.012.31.267.556.577.556.338 0 .604.288.576.625l-.763 9.143a.896.896 0 0 1-.893.821h-.193a.701.701 0 0 0 0 1.403l4.952.009v5.884a.706.706 0 1 0 1.41 0l.002-5.884 4.953-.01a.701.701 0 0 0-.001-1.402h-.194a.896.896 0 0 1-.892-.822l-.762-9.154a.567.567 0 0 1 .565-.614Z"
}));
export default PinIcon;